export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4696.1e4ace1c.jpg";